import { render, staticRenderFns } from "./SkillActivitiesTable.vue?vue&type=template&id=28073516&scoped=true&"
import script from "./SkillActivitiesTable.vue?vue&type=script&lang=js&"
export * from "./SkillActivitiesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28073516",
  null
  
)

export default component.exports